<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconRaiseHand_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M21.947 8.959a1.433 1.433 0 0 0-1.764 1.01l-1.149 4.19-1.382-.386 2.295-8.38a1.45 1.45 0 0 0-1-1.784 1.433 1.433 0 0 0-1.765 1.01L14.887 13l-1.383-.386 2.679-9.778a1.45 1.45 0 0 0-1-1.783 1.433 1.433 0 0 0-1.765 1.01L10.74 11.84l-1.382-.386 2.295-8.381a1.45 1.45 0 0 0-1-1.783 1.43 1.43 0 0 0-1.764 1.01c-.21.772-3.018 11.016-3.186 11.632s-.985.618-1.125-.005c-.11-.485-.453-2.297-.696-3.597a1.455 1.455 0 0 0-1.65-1.178A1.46 1.46 0 0 0 1 10.602c.005 1.113.023 2.77.083 4.154.234 5.393 5.498 7.887 8.05 8.601 3.147.88 6.187.983 8.482-.495 1.58-1.018 2.828-2.979 3.428-5.168l1.905-6.952a1.45 1.45 0 0 0-1-1.783"
    />
</svg>
